import {MessageCollection} from "../messages/api.models";

interface MessagecentralPreferencesInterface {
    defaultMessageCollection: MessageCollection;
}

interface MessagecentralInterface {
    id: number;
    name: string;
    apiUrl: string;
    apiToken: string;
    preferences: MessagecentralPreferencesInterface;
    lastImport: string;
    isImportingEnabled: boolean;
}

class MessagecentralPreferences implements MessagecentralPreferencesInterface {
    defaultMessageCollection: MessageCollection = new MessageCollection();
}

class Messagecentral implements MessagecentralInterface {
    apiToken: string;
    apiUrl: string;
    id: number;
    isImportingEnabled: boolean = false;
    lastImport: string;
    name: string;
    preferences: MessagecentralPreferencesInterface = new MessagecentralPreferences();
}

export {
    MessagecentralPreferencesInterface,
    MessagecentralInterface,
    MessagecentralPreferences,
    Messagecentral
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/shared/api/messagecentrals/api.models.ts